__turbopack_context__.v({
  "buttonWrapper": "Hits-module-scss-module__JOoFta__buttonWrapper",
  "newHit": "Hits-module-scss-module__JOoFta__newHit",
  "searchHitsCrossLinking": "Hits-module-scss-module__JOoFta__searchHitsCrossLinking",
  "searchHitsItem": "Hits-module-scss-module__JOoFta__searchHitsItem",
  "searchHitsItemWide": "Hits-module-scss-module__JOoFta__searchHitsItemWide",
  "searchHitsList": "Hits-module-scss-module__JOoFta__searchHitsList",
  "searchHitsRoot": "Hits-module-scss-module__JOoFta__searchHitsRoot",
});
